<div class="wrapper">
  <div class="header">
    <span class="backBtn clickable" (click)="toCommands()">
      <img src="assets/Keen&Wise_back.png" />
      Commands
    </span>
    <div class="failed-actions">
      <button (click)="restartCommand(commandDetails.Id)" class="refresh-btn restart-skip-validation" *ngIf="
      canRestartCommand()
        && ShowRestartButton
    ">
        <mat-icon class="image-rotate">keyboard_tab</mat-icon>
        <span class="refresh-text">Restart and skip validation</span>
        
      </button>

      <div class="refresh">
        <button (click)="refreshData()" class="refresh-btn">
          <span class="refresh-text">Refresh Data</span>
          <img src="assets/Keen&Wise_retry.svg" />
        </button>
      </div>
    </div>
    
  </div>
  <div class="body" *ngIf="commandDetails">
    <div *ngIf="commandDetails.Id" class="command-field title">
      <span class="command-field-title">Command Id:</span>
      <span class="command-field-content">{{ commandDetails.Id }}</span>
    </div>
    <div *ngIf="commandDetails.Title" class="command-field title">
      <span class="command-field-title">Command Type:</span>
      <span class="command-field-content">{{ commandDetails.Title }}</span>
    </div>
    <div *ngIf="commandDetails.ExecutedOn" class="command-field payload">
      <span class="command-field-title">Executed On:</span>
      <span class="command-field-content">{{
        commandDetails.ExecutedOn | date: "dd/MM/yyyy HH:mm:ss"
      }}</span>
    </div>
    <div *ngIf="commandDetails.Payload" class="command-field payload">
      <span class="command-field-title">Payload:</span>
      <span class="command-field-content">{{ commandDetails.Payload }}</span>
    </div>
    <p-accordion>
      <p-accordionTab
        *ngIf="commandLogs && commandLogs.length !== 0"
        header="Logs"
      >
        <div class="logs">
          <div
            class="log"
            [ngClass]="log.collapsed ? 'log-collapsed' : 'log-full'"
            *ngFor="let log of commandLogs"
          >
            <div class="log-message">
              <span>{{ log.message }}</span>
            </div>
            <div class="log-time">
              <span>{{ log.loggedOn | date: "dd/MM/yyyy HH:mm:ss" }}</span>
              <span>
                <img
                  (click)="log.collapsed = !log.collapsed"
                  class="collapsible-icon"
                  [class.open]="!log.collapsed"
                  src="assets/icon-expand.svg"
                  alt="expand/collapse"
                />
              </span>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab
        header="Attempts"
        *ngIf="commandDetails.Attempts.length !== 0"
      >
        <div *ngFor="let attempt of commandDetails.Attempts" class="attempt">
          <span *ngIf="attempt.Id"><b>Id:</b> {{ attempt.Id }}</span>
          <span *ngIf="attempt.Source"><b>Src:</b> {{ attempt.Source }}</span>
          <span *ngIf="attempt.State"
            ><b>State:</b> {{ commandHandelingState[attempt.State] }}</span
          >
          <span *ngIf="attempt.StartDate"
            ><b>Started On:</b>:
            {{ attempt.StartDate | date: "dd/MM/yyyy HH:mm:ss" }}</span
          >
          <span *ngIf="attempt.FullError"
            ><b>Error:</b> {{ attempt.FullError }}</span
          >
        </div>
      </p-accordionTab>
      <p-accordionTab header="Steps" *ngIf="commandDetails.Steps.length !== 0">
        <div *ngFor="let step of commandDetails.Steps" class="step">
          <span *ngIf="step.Id"><b>Id:</b> {{ step.Id }}</span>
          <span *ngIf="step.Step"><b>Step:</b> {{ step.Step }}</span>
          <span *ngIf="step.State"
            ><b>State:</b> {{ commandStepState[step.State] }}</span
          >
          <span *ngIf="step.Timestamp"
            ><b>Timestamp:</b>
            {{ step.Timestamp | date: "dd/MM/yyyy HH:mm:ss" }}</span
          >
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
